import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import PropTypes from 'prop-types';

const PremiumHotel = props => {
  const { id, bgImage, propertyName, flyToMarker, hotelInfo, other } = props;
  return (
    <div className='premiumDiv' id={id}>
      <img src={bgImage} className='bgImage' loading='lazy' />
      <span
        className='fa-layers fa-fw fa-2x markerCircle'
        onClick={flyToMarker}
      >
        <FontAwesomeIcon icon={['fas', 'circle']} className='circle' />
        <FontAwesomeIcon icon={['fas', 'map-marker-alt']} className='marker' />
      </span>
      <div className='premiumInfoDiv' onClick={hotelInfo}>
        <span className='premiumName'> {propertyName}</span> <br />
        <br />
        <span className='premiumCity'>
          {other.city && other.city + ', '}
          {other.country}
        </span>
        <br />
        <br />
        <span className='moreInfo'>View Now ></span>
      </div>
    </div>
  );
};

PremiumHotel.propTypes = {
  id: PropTypes.string,
  bgImage: PropTypes.string,
  propertyName: PropTypes.string,
  flyToMarker: PropTypes.func,
  hotelInfo: PropTypes.func,
  other: PropTypes.object,
};

PremiumHotel.defaultProps = {
  id: '',
  bgImage: '',
  propertyName: '',
  flyToMarker: () => {},
  hotelInfo: () => {},
  other: [],
};

export default PremiumHotel;
